const navicon = document.querySelector('.header__navicon');
const nav = document.querySelector('.header__nav');
const blur = document.querySelector('.blur');

const toggleNav = () => {
	const isActive = nav.classList.contains('header__nav--active');
	navicon.setAttribute('aria-expanded', !isActive);
	blur.classList.toggle('blur--active');
	nav.classList.toggle('header__nav--active');
	navicon.classList.toggle('header__navicon--active');
}

if (navicon && nav && blur) {
	navicon.addEventListener('click', toggleNav);
	blur.addEventListener('click', toggleNav);
}

